import {
  ArrayField,
  ArrayFieldProps,
  Datagrid,
  NumberField,
  TextField,
} from 'react-admin';
import { QuickbooksPriceField } from '../components/QuickbooksPriceField';

export const TaxesArrayField = (props: Omit<ArrayFieldProps, 'children'>) => {
  return (
    <ArrayField {...props}>
      <Datagrid bulkActionButtons={false}>
        <TextField source="TaxLineDetail.TaxRateRef.value" label="Tax Name"/>
        <NumberField source="TaxLineDetail.TaxPercent" label="Tax Percent" />
        <NumberField source="TaxLineDetail.NetAmountTaxable" label="Amount Taxed"/>
        <QuickbooksPriceField source="Total Tax" />
      </Datagrid>
    </ArrayField>
  );
};
